import { createRoutine } from '@hozana/routines/functions'

import { TUserPrayPopinOptions } from 'modules/pray/popins/UserPrayPopin'
import type { TPrayUserPayload } from 'modules/pray/sagas'

export const prayUser = createRoutine<'PRAY_USER', TPrayUserPayload, TUserPrayPopinOptions>('PRAY_USER')
